import { Window } from '@execonline-inc/browser-window.private';
import { emptyFragment, ListItem } from '@execonline-inc/execonline-ui';
import { just } from 'maybeasy';
import { observer } from 'mobx-react';
import { CurrentUserResource } from '../../../../../CurrentUser/Types';
import { T } from '../../../../../Translations';
import { supportMenu } from '../../SupportMenu/Types';

export interface Props {
  user: CurrentUserResource;
  onClick: () => void;
}

function SupportMenu({ user, onClick }: Props) {
  const handleClick = (href: string) => () => {
    onClick();
    Window.openWindow(href, '_blank', { noopener: just(true), noreferrer: just(true) });
  };

  return supportMenu(user)
    .map(({ href }) => (
      <ListItem role="menuitem" aria-label="Support" onClick={handleClick(href)}>
        <T kind="Support" />
      </ListItem>
    ))
    .getOrElse(emptyFragment);
}

export default observer(SupportMenu);
